import React, { useState, useRef } from 'react';
import { Menu, X, ChevronDown } from 'lucide-react';
import { Link } from 'react-router-dom';

const HeadersNonAuth = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isLearnDropdownOpen, setIsLearnDropdownOpen] = useState(false);
  const dropdownTimeoutRef = useRef(null);

  const handleLearnMouseEnter = () => {
    if (dropdownTimeoutRef.current) {
      clearTimeout(dropdownTimeoutRef.current);
    }
    setIsLearnDropdownOpen(true);
  };

  const handleLearnMouseLeave = () => {
    dropdownTimeoutRef.current = setTimeout(() => {
      setIsLearnDropdownOpen(false);
    }, 300); // 300ms delay before closing
  };

  const handleDropdownMouseEnter = () => {
    if (dropdownTimeoutRef.current) {
      clearTimeout(dropdownTimeoutRef.current);
    }
    setIsLearnDropdownOpen(true);
  };

  const handleDropdownMouseLeave = () => {
    dropdownTimeoutRef.current = setTimeout(() => {
      setIsLearnDropdownOpen(false);
    }, 300); // 300ms delay before closing
  };

  return (
    <nav className="fixed top-0 left-0 w-full z-50 bg-[#0b0d2a] flex justify-between items-center px-4 lg:px-20 py-2 sm:py-2 text-white shadow-sm font-sans">
      <a href="/" className="flex items-center ">
        <img
          src="/logojt.png"
          alt="JTNCBOT Logo"
          className="h-[80px] w-[300px] object-cover -mt-0"
        />
      </a>
      
      {/* Center Menu - Desktop */}
      <div className="flex-1 hidden lg:flex justify-center -mt-2">
        <ul className="flex space-x-6 items-center text-sm">
          <li><a href="/why-quantum" className="hover:text-cyan-300">Why Quantum Flo Auto Algo?</a></li>
          <li><a href="/solutions" className="hover:text-cyan-300">Solutions</a></li>
          <li><a href="/how-it-works" className="hover:text-cyan-300">How it works</a></li>
          <li><a href="/pricing" className="hover:text-cyan-300">Pricing</a></li>
          <li className="relative">
            <button
              className="flex items-center hover:text-cyan-300"
              onMouseEnter={handleLearnMouseEnter}
              onMouseLeave={handleLearnMouseLeave}
            >
              Learn
              <ChevronDown className="ml-1 w-4 h-4" />
            </button>
            {isLearnDropdownOpen && (
              <div
                className="absolute top-full left-0 mt-2 w-64 bg-[#0b0d2a] border border-gray-700 rounded-lg shadow-xl py-2"
                onMouseEnter={handleDropdownMouseEnter}
                onMouseLeave={handleDropdownMouseLeave}
              >
                <a href="/options-101" className="block px-4 py-2 text-sm text-gray-300 hover:text-white hover:bg-gray-800">Option 101</a>
                <a href="/what-is-market-making" className="block px-4 py-2 text-sm text-gray-300 hover:text-white hover:bg-gray-800">What is Market Making</a>
                <a href="/how-to-place-an-options-trade" className="block px-4 py-2 text-sm text-gray-300 hover:text-white hover:bg-gray-800">How to Place an Options trade</a>
                <a href="/position-size-and-risk-management" className="block px-4 py-2 text-sm text-gray-300 hover:text-white hover:bg-gray-800">Position Size and Risk Management</a>
                <a href="/pattern-day-trader-rule" className="block px-4 py-2 text-sm text-gray-300 hover:text-white hover:bg-gray-800">Pattern Day Trader Rule</a>
                <a href="/how-to-handle-options-assignment" className="block px-4 py-2 text-sm text-gray-300 hover:text-white hover:bg-gray-800">How to Handle Options Assignment</a>
              </div>
            )}
          </li>
          <li><a href="/company" className="hover:text-cyan-300">Company</a></li>
        </ul>
      </div>

      {/* Sign-in/Sign-up - Desktop */}
      <div className="hidden lg:flex items-center space-x-4 whitespace-nowrap">
        <a href="/login" className="hover:text-cyan-300">Sign in</a>
        <a href="/pricing" className="px-4 py-2 rounded-lg bg-cyan-400 text-[#0b0d2a] font-semibold text-sm">Sign up</a>
      </div>

      {/* Mobile Menu Toggle */}
      <button className="lg:hidden z-50" onClick={() => setIsMenuOpen(!isMenuOpen)}>
        {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
      </button>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="absolute top-16 left-0 right-0 bg-[#0b0d2a] px-6 py-6 shadow-lg rounded-b-2xl lg:hidden text-center text-white">
            <ul className="flex flex-col space-y-4 text-sm mb-6">
            <li><a href="/why-quantum" className="hover:text-cyan-300">Why Quantum Flo Auto Algo?</a></li>
            <li><a href="/solutions" className="hover:text-cyan-300">Solutions</a></li>
            <li><a href="/how-it-works" className="hover:text-cyan-300">How it works</a></li>
            <li><a href="/pricing" className="hover:text-cyan-300">Pricing</a></li>
            <li>
              <div className="space-y-2">
                <div className="font-medium">Learn</div>
                <div className="pl-4 space-y-2 text-sm">
                  <a href="/options-101" className="block hover:text-cyan-300">Option 101</a>
                  <a href="/what-is-market-making" className="block hover:text-cyan-300">What is Market Making</a>
                  <a href="/how-to-place-an-options-trade" className="block hover:text-cyan-300">How to Place an Options trade</a>
                  <a href="/position-size-and-risk-management" className="block hover:text-cyan-300">Position Size and Risk Management</a>
                  <a href="/pattern-day-trader-rule" className="block hover:text-cyan-300">Pattern Day Trader Rule</a>
                  <a href="/how-to-handle-options-assignment" className="block hover:text-cyan-300">How to Handle Options Assignment</a>
                </div>
              </div>
            </li>
            <li><a href="/company" className="hover:text-cyan-300">Company</a></li>
            <li><a href="/login" className="hover:text-cyan-300">Sign in</a></li>
            <li>
              <a
                href="/pricing"
                className="inline-block px-5 py-2 rounded-lg bg-cyan-400 text-[#0b0d2a] font-semibold hover:bg-cyan-300"
              >
                Sign up
              </a>
            </li>
          </ul>
        </div>
      )}
    </nav>
  );
};

export default HeadersNonAuth;

